import { connectionsSlice } from "./slice";

export const { addConnection, removeConnection, toggleConnection } =
	connectionsSlice.actions;
